export default __webpack_public_path__ + "static/vuengine-studio-e8c2c71cec497ffe39a57442c029cb27.png";